<template>
  <div
    class="w-full pl-[15px] pr-2.5 py-2.5 rounded-[12px] border border-[#ebedef] flex items-center text-[14px] text-gray-800"
  >
    <div class="min-w-9 max-w-9 h-9 mr-[15px]">
      <Thumbnail :type="thumbType" :src="imageUrl" />
    </div>
    <div class="w-full leading-[18px]" v-truncate>
      <div data-truncate-target class="font-medium text-[15px] mb-1">
        {{ props.file.metadata.originalFilename }}
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { File } from '@/shared/graphql/router/graphql'
import { applyAuthorizationToken } from '@/shared/utils/url'
import { Thumbnail } from '@dacr/library'
import { fileTypeToThumbnail } from '@/shared/utils/thumbnail'
import { computed } from 'vue'

const props = defineProps<{
  file: File
}>()

const imageUrl = computed(() =>
  props.file.asset?.previewImageUrl
    ? applyAuthorizationToken(props.file.asset.previewImageUrl)
    : undefined
)

const thumbType = computed(() => fileTypeToThumbnail(props.file.type))
</script>
